import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-fehlerart-list-view',
  imports: [],
  templateUrl: './fehlerart.list-view.html',
  styleUrls: ['./fehlerart.list-view.css'],
})
export class FehlerartListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
